import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../auth/withAuth';
import { userClient } from '../client';

export let usersLoader = createLoader({
  name: 'users',
  fetch: () => withAuth(() => userClient.users.getAuthenticatedUsers({})),
  mutators: {}
});

export let useLoggedInUsers = () => usersLoader.use();
